module.exports = __webpack_public_path__ + "img/logo_u1992-28.466d33fb.png";